export const getScreenOrientation = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  if (!isMobile) {
    return 'horizontal'
  }

  return window.matchMedia('(orientation: landscape)').matches ? 'horizontal' : 'vertical'
}

export const isScreenHorizontal = () => {
  return getScreenOrientation() === 'horizontal'
}
